import { singleton } from "tsyringe";

import { IUserProvider } from "@/Infrastructure/UserProvider";
import User from "@/Model/User";

@singleton()
export class UserProviderImpl implements IUserProvider {
    private user: User;

    constructor() {
        this.user = new User();
    }

    public getUser(): User {
        return this.user;
    }
}